import { ArticleCard } from '@xing-com/crate-career-hub-article-card';
import { CAREER_HUB_BASE_PATH } from '@xing-com/crate-career-hub-common';
import { GridItem } from '@xing-com/grid';
import { IconArrowRight } from '@xing-com/icons';
import { Headline } from '@xing-com/typography';

import { TO_ARTICLE } from '../constants';

import { ArticleBlockWrapper } from './article-block-wrapper';
import { Styled } from './topic-card.styles';

type Article = {
  title: string;
  imageSrc?: string;
  description: string;
  url: string;
  pageTitle: string;
  profileImage: string;
};

export type TopicType = {
  articles: (Article | null)[];
  slug: string;
  title: string;
};

export const TopicCard: React.FC<TopicType> = ({ articles, slug, title }) => (
  <>
    <header>
      <Styled.HeaderWrapper>
        <Headline size="xxlarge" noMargin>
          {title}
        </Headline>
        <Styled.TextButton
          data-qa="career-hub-more-button"
          to={`${CAREER_HUB_BASE_PATH}/${slug}`}
          icon={IconArrowRight}
          iconAfter
        >
          {TO_ARTICLE}
        </Styled.TextButton>
      </Styled.HeaderWrapper>
    </header>
    <ArticleBlockWrapper>
      {articles?.map(
        (article) =>
          article && (
            <GridItem key={article.title} spanMedium={6} spanLarge={4}>
              <ArticleCard
                {...{
                  pageTitle: article?.pageTitle,
                  description: article?.description,
                  imageSrc: article?.imageSrc ?? '',
                  title: article?.title,
                  url: `${article?.url}?sc_o=career_hub_main_page_article_click`,
                  profileImage: article?.profileImage ?? '',
                }}
              />
            </GridItem>
          )
      )}
    </ArticleBlockWrapper>
  </>
);
